export default {"src":"/_next/static/media/SNOW.b32457e8.svg","height":18,"width":18};